import { useCallback, useMemo, useState } from "react";
import { ViewTable } from "@design-system/ViewTable/ViewTable";
import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { View } from "@common/types/views/views";
import { useGlobalTransactionViewDrawer } from "@components/transactions/TransactionViewDrawer/useGlobalTransactionViewDrawer";
import styles from "../HistoryDetails.module.scss";
import {
    FieldReviewDetailsRow,
    FieldReviewTableMeta,
    fieldReviewDetailsViewConfig,
} from "./fieldReviewDetailsViewConfig";
import { defaultFieldReviewDetailsView } from "./defaultFieldReviewDetailsView";

interface FieldReviewDrawerTableProps {
    rows: FieldReviewDetailsRow[];
    entityIds?: number[];
    footer: React.ReactNode;
}

export const FieldReviewDrawerTable: React.FC<FieldReviewDrawerTableProps> = ({
    rows,
    entityIds,
    footer,
}) => {
    const [view, setView] = useState<View>(defaultFieldReviewDetailsView);
    const openTransactionViewDrawer = useGlobalTransactionViewDrawer();

    const handleRowAction = useCallback(
        (row: FieldReviewDetailsRow) => {
            if (!row.transactionId) {
                return;
            }
            openTransactionViewDrawer({
                entityIds: entityIds ?? [],
                transactionIds: [row.transactionId],
            });
        },
        [entityIds, openTransactionViewDrawer],
    );

    const handleRowClick = useCallback(
        (row?: FieldReviewDetailsRow) => {
            if (!row) {
                return;
            }
            handleRowAction(row);
        },
        [handleRowAction],
    );

    const tableMeta: FieldReviewTableMeta = useMemo(
        () => ({ callbacks: { onRowAction: handleRowAction } }),
        [handleRowAction],
    );

    return (
        <ViewTable
            data={rows}
            view={view}
            config={fieldReviewDetailsViewConfig}
            onViewChange={setView}
            onRowClick={handleRowClick}
            emptyView={() => (
                <EmptyState header="No review status changes found" />
            )}
            footer={footer}
            tableMeta={tableMeta}
            className={styles.historyDetailsView}
        />
    );
};
